module.exports = __webpack_public_path__ + "static/media/gy.cbacc8b8.svg";